exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "select.selected[data-v-9c9ffa54]{color:#000}.m-0[data-v-9c9ffa54]{margin:0}.mr-2[data-v-9c9ffa54]{margin-right:.5rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9c9ffa54","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/app/components/SelectCarDropdown.vue
// module id = L8Gx
// module chunks = 1